import {Col, Empty, Row} from "@douyinfe/semi-ui";
import {useNavigate} from "react-router-dom";
import {IllustrationNotFound, IllustrationNotFoundDark} from '@douyinfe/semi-illustrations';


export default function NotFound(){
    let nav = useNavigate()
    return <div style={{marginTop: "50px"}}>
        <Row>
            <Col span={24}>
                <Col offset={6} span={12}>
                    <Empty
                        image={<IllustrationNotFound style={{width: 150, height: 150}} />}
                        darkModeImage={<IllustrationNotFoundDark style={{width: 150, height: 150}} />}
                        title={'没找到页面'}
                        description={`页面路径 /${window.location.hash.replace("#/", "")}`}
                    />
                </Col>
            </Col>
        </Row>

    </div>
}